import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

const Card = ({ onClick, children, className = '', ...props }) => {
	return (
		<div
			className={twMerge('bg-white rounded-card border border-bgBase-500 p-4', className)}
			onClick={onClick}
			{...props}
		>
			{children}
		</div>
	);
};

Card.propTypes = {
	onClick: PropTypes.func,
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};

export default Card;
